// extracted by mini-css-extract-plugin
export var pillWrapper = "_ym-0";
export var showOverflow = "_ym-1";